<template>
    <v-app>
        <vue-headful title="ePlato"/>
        <toolbar
                :is-lang-switcher="false"
                color="teal darken-4"
                @toggleDrawer="drawerApp = !drawerApp"
        />

        <navigation @toggleDrawer="drawerApp = $event" :drawer="drawerApp"/>

        <v-main>
            <router-view/>
        </v-main>
        <snack-displayer/>
    </v-app>
</template>

<script>
    import Toolbar from "../../components/common/Toolbar";
    import SnackDisplayer from "../../components/common/SnackDisplayer";
    import RatingAdminNavigationDrawer from "../../components/ratingAdmin/common/RatingAdminNavigationDrawer";

    export default {
        components: {
            Toolbar,
            navigation: RatingAdminNavigationDrawer,
            snackDisplayer: SnackDisplayer,
        },
        data: () => ({
            drawerApp: true,
            drawerTeacherNav: false,
        }),
    }
</script>
